import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 통합관리일반회원리스트
const get_adminplayerlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 10,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist",
    params: {
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
      hc_status: params.hc_status,
      pagesize: params.pagesize,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_adminplayerlist", err);
    result(false, err);
  }
};

// 통합관리일반회원정보보기
const get_adminplayerinfo = async (playerno, result) => {
  let finalData = {
    code: 200,
    message: "",
    memberinfo: [
      {
        id: "",
        nickname: "",
        firstname: "",
        lastname: "",
        email: "",
        membertype: "",
        timezone: "",
        daylighttime: "",
        gender: "",
        hand: "",
        teeheight: "",
        fieldunit: "",
        greenunit: "",
        speedunit: "",
        emailagree: "",
        status: "",
        handi_9: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/membership/playerview/" + playerno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminplayerinfo", err);
    result(false, err);
  }
};

// 통합관리일반회원수정
const set_adminplayeredit = async (playerno, memberinfo, result) => {
  let finalData = {
    code: 200,
    message: "",
  };
  const options = {
    method: "POST",
    url: "/postact/playeredit/" + playerno,
    data: qs.stringify({
      handicap_index: memberinfo.handicap_index,
      status: memberinfo.status,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_adminplayeredit", err);
    result(false, err);
  }
};

// 통합관리매장회원리스트
const get_adminownerlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 10,
    ownerlistcnt: "0",
    ownerlist: [],
  };
  const options = {
    method: "GET",
    url: "/ownership/ownerlist",
    params: {
      ownertype: params.ownertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
      platform_type: params.platform_type,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    console.error("get_adminownerlist", err);
    result(false, err, response.data.code);
  }
};

// 통합관리매장회원정보보기
const get_adminownerinfo = async (ownerno, result) => {
  let finalData = {
    code: 200,
    message: "",
    ownerinfo: {
      id: "",
      shopname: "",
      email: "",
      membertype: 1,
      timezone: "",
      daylighttime: 0,
      fieldunit: 0,
      greenunit: 0,
      speedunit: 0,
      emailagree: 0,
      firstname: "",
      lastname: "",
      statesno: "",
      city: "",
      address: "",
      zipcode: "",
      phone: "",
      fax: "",
      website: "",
      status: "",
      ownertype: "",
    },
  };
  const options = {
    method: "GET",
    url: "/ownership/ownerview/" + ownerno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminownerinfo", err);
    result(false, err);
  }
};

// 국가리스트
const get_countrylist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    countrylistcnt: 0,
    countrylist: [],
  };

  const options = {
    method: "GET",
    url: "/common/countrylist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_countrylist", err);
    result(false, err);
  }
};

// 지역리스트(주)
const get_stateslist = async (countryno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/stateslist/" + countryno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_stateslist", err);
    result(false, err);
  }
};

// 지역리스트(시)
const get_citylist = async (statesname, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    citylistcnt: 0,
    citylist: [],
  };

  const options = {
    method: "GET",
    url: "/common/citylist/" + statesname,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_citylist", err);
    result(false, err);
  }
};

// 중복체크2(수정)
const availability_check2 = async (shopno, type, name, result) => {
  let url = "";
  let data = {};
  if (type === 2) {
    url = "ajax_nickname_check";
    data = { shopno: shopno, nickname: name };
  }
  if (type === 3) {
    url = "ajax_email_check";
    data = { shopno: shopno, email: name };
  }

  const options = {
    method: "POST",
    url: "/ownership/" + url,
    data: qs.stringify(data),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    console.error("availability_check2", err);
    result(false, err);
  }
};

// 통합관리매장회원수정
const set_adminowneredit = async (ownerno, form, result) => {
  const options = {
    method: "POST",
    url: "/ownership/ownerwrite/" + ownerno,
    data: qs.stringify({
      password: form.password,
      shopnameoverlap: form.shopnameoverlap,
      shopname: form.shopname,
      emailoverlap: form.emailoverlap,
      email: form.email,
      ownertype: form.ownertype,
      platform_type: form.platform_type,
      timezone: form.timezone,
      daylighttime: form.daylighttime,
      fieldunit: form.fieldunit,
      greenunit: form.greenunit,
      speedunit: form.speedunit,
      agreeemail: form.emailagree,
      firstname: form.firstname,
      lastname: form.lastname,
      statesno: form.statesno,
      countryno: form.countryno,
      city: form.city,
      address: form.address,
      zipcode: form.zipcode,
      phone: form.phone,
      fax: form.fax,
      website: form.website,
      status: form.status,
      oldroomcnt: form.oldroomcnt,
      roomcnt: form.roomcnt,
      etcinfo: form.etcinfo,
      lockercnt: form.lockercnt,
      address_lat: form.address_lat,
      address_lng: form.address_lng,
    }),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    console.error("set_adminowneredit", err);
    result(false, err);
  }
};

// 중복체크(가입)
const availability_check = async (type, name, result) => {
  let url = "";
  let data = {};
  if (type === 1) {
    url = "ajax_owner_id_check";
    data = { owner_id: name };
  }
  if (type === 2) {
    url = "ajax_nickname_check";
    data = { nickname: name };
  }
  if (type === 3) {
    url = "ajax_email_check";
    data = { email: name };
  }

  const options = {
    method: "POST",
    url: "/ownership/" + url,
    data: qs.stringify(data),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("availability_check", err);
    result(false, err);
  }
};

// 지역좌표
const address_check = async (addresslist, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    addressinfo: [],
  };

  const options = {
    method: "POST",
    url: "/common/ajax_address_check",
    data: qs.stringify({
      addresslist: addresslist,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("address_check", err);
    result(false, err);
  }
};

// 통합관리매장회원수정
const set_adminownerregister = async (form, result) => {
  const options = {
    method: "POST",
    url: "/ownership/ownerwrite",
    data: qs.stringify({
      id: form.id,
      idoverlap: form.idoverlap,
      password: form.password,
      shopnameoverlap: form.shopnameoverlap,
      shopname: form.shopname,
      emailoverlap: form.emailoverlap,
      email: form.email,
      ownertype: form.ownertype,
      platform_type: form.platform_type,
      timezone: form.timezone,
      daylighttime: form.daylighttime,
      fieldunit: form.fieldunit,
      greenunit: form.greenunit,
      speedunit: form.speedunit,
      agreeemail: form.emailagree,
      firstname: form.firstname,
      lastname: form.lastname,
      statesno: form.statesno,
      countryno: form.countryno,
      state: form.state,
      city: form.city,
      address: form.address,
      zipcode: form.zipcode,
      phone: form.phone,
      fax: form.fax,
      website: form.website,
      roomcnt: form.roomcnt,
      etcinfo: form.etcinfo,
      lockercnt: form.lockercnt,
      address_lat: form.address_lat,
      address_lng: form.address_lng,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_adminownerregister", err);
    result(false, err);
  }
};

// 통합관리매장회원장비리스트
const get_adminownerroomlist = async (ownerno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    ownerroomlistcnt: 0,
    ownerroomlist: [],
  };

  const options = {
    method: "GET",
    url: "/app/member/ownerroomlist.php",
    params: {
      ownerno: ownerno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminownerroomlist", err);
    result(false, err);
  }
};

// 통합관리매장회원HW리스트
const get_adminownerhwlist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    ownerhwlistcnt: 0,
    ownerhwlist: [],
  };

  const options = {
    method: "GET",
    url: "/ownership/ownerroomhwlist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminownerhwlist", err);
    result(false, err);
  }
};

// 통합관리매장회원SW리스트
const get_adminownerswlist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    ownerswlistcnt: 0,
    ownerswlist: [],
  };

  const options = {
    method: "GET",
    url: "/ownership/ownerroomswlist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_adminownerswlist", err);
    result(false, err);
  }
};

// 통합관리매장회원장비등록
const set_adminownerroomewrite = async (form, result) => {
  const options = {
    method: "POST",
    url: "/ownership/ownerroomwrite/" + form.ownerno,
    data: qs.stringify({
      roomno: form.roomno,
      roomname: form.roomname,
      maincode: form.maincode,
      subcode: form.subcode,
      etccode: form.etccode,
      hwmodelno: form.hwmodelno,
      swmodelno: form.swmodelno,
      installdate: form.installdate,
      roomstatus: form.roomstatus,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_adminownerroomewrite", err);
    result(false, err);
  }
};

// 통합관리매장회원장비수정
const set_adminownerroomedit = async (form, result) => {
  console.log(form);
  const options = {
    method: "POST",
    url: "/ownership/ownerroomwrite/" + form.ownerno,
    data: qs.stringify({
      roomno: form.roomno,
      roomname: form.roomname,
      maincode: form.maincode,
      subcode: form.subcode,
      etccode: form.etccode,
      hwmodelno: form.hwmodelno,
      swmodelno: form.swmodelno,
      installdate: form.installdate,
      roomstatus: form.roomstatus,
      api_pk: form.api_pk,
      simulator_pk: form.simulator_pk,
      token: form.token,
      expdate: form.expdate,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_adminownerroomedit", err);
    result(false, err);
  }
};

// 포인트 통합관리
const get_adminpointlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: "1",
    pagesize: 10,
    pointlistcnt: "0",
    pointlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/pointlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const add_point = async (sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/membership/addpoint",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const remove_point = async (sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };
  console.log(sendData);
  const options = {
    method: "POST",
    url: "/postact/removepoint",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const get_adminownerroominfo = async (ownerno, roomno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    roominfo: [
      {
        no: null,
        roomno: null,
        roomname: null,
        maincode: null,
        subcode: null,
        etccode: null,
        hwmodelno: null,
        swmodelno: null,
        installdate: null,
        roomstatus: null,
      },
    ],
  };
  const options = {
    method: "GET",
    // url: '/app/room/roominfo.php',
    url: "/ownership/ownerroomview/" + ownerno,

    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: {
      roomno: roomno,
    },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const token_check = async (form, result) => {
  const options = {
    method: "POST",
    url: "/ownership/ajax_token_check",
    data: qs.stringify({
      token: form.token,
      simulator_pk: form.simulator_pk,
    }),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("token_check", err);
    result(false, err);
  }
};

// 타임존리스트(주)
const get_timezonelist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/timezonelist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_timezonelist", err);
    result(false, err);
  }
};

// 통합관리일반회원핸디수정
const set_playerhandicap = async (playerno, handicap_form, result) => {
  let finalData = {
    code: 200,
    message: "",
  };
  const options = {
    method: "POST",
    url: "/postact/playerhandicap/" + playerno,
    data: qs.stringify({
      handicap_index: handicap_form.handicap_index,
      writer: handicap_form.writer,
      handicap_auto: handicap_form.handicap_auto,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_playerhandicap", err);
    result(false, err);
  }
};

// 핸디 통합관리
const get_handilist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: "1",
    pagesize: 10,
    handilist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/handilist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const excelSave = async (param, result) => {
  let finalData = {
    code: 0,
    message: "",
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist/excel",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    // alert(response.headers["content-disposition"]);
    // console.log(response);
    //  let header = response.headers["Content-Disposition"];

    // let filenameTmp = header.split("=");
    // let filename = filenameTmp[1];
    // let filename = "member_". date("Y-m-d") .".xls";

    result(response.data);
  });
};

export default {
  get_adminplayerlist,
  get_adminplayerinfo,
  set_adminplayeredit,
  get_adminownerlist,
  get_adminownerinfo,
  get_countrylist,
  get_stateslist,
  get_citylist,
  get_adminpointlist,
  availability_check2,
  set_adminowneredit,
  availability_check,
  address_check,
  set_adminownerregister,
  get_adminownerroomlist,
  get_adminownerhwlist,
  get_adminownerswlist,
  set_adminownerroomewrite,
  set_adminownerroomedit,
  add_point,
  remove_point,
  get_adminownerroominfo,
  token_check,
  get_timezonelist,
  set_playerhandicap,
  get_handilist,
  excelSave,
};
